import type { ISubscriptionEventsApiPort } from '@subscriptions/application/ports';
import type { SubscriptionEventViewDto } from '@subscriptions/application/dtos';
import type { SubscriptionEventsHttpClientType } from '@subscriptions/infrastructure/api/SubscriptionEventsHttpClient';
import type { SubscriptionEventsApiMapperType } from '@subscriptions/infrastructure/mappers/SubscriptionEventsApiMapper';

/**
 * Creates the subscription events repository implementing ISubscriptionEventsApiPort.
 * Orchestrates HTTP client and mapper to fulfill application contracts.
 */
export const createSubscriptionEventsApiRepository = (props: {
  httpClient: SubscriptionEventsHttpClientType;
  mapper: SubscriptionEventsApiMapperType;
}): ISubscriptionEventsApiPort => {
  const { httpClient, mapper } = props;

  const list = async (): Promise<SubscriptionEventViewDto[]> => {
    const apiResponse = await httpClient.list();

    return mapper.mapApiResponseListToViewDtos(apiResponse);
  };

  return { list };
};
